<template>
  <div class="container-fluid">
    <loading :active.sync="isLoading" :is-full-page="false"></loading>

    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">Edit {{ module }}</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboards' }">Dashboards</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{ name: table_module }">{{ module }}</router-link>
              </li>
              <li class="breadcrumb-item active">Edit</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="loaded">
      <div class="col-12">
        <div class="card">
          <div class="card-body">

            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label>No. Opname</label>
                  <input type="text" class="form-control" v-model="form.so_no" />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>Tanggal <span class="text-danger">*</span></label>
                  <date-picker
                    v-model="form.so_date"
                    format="YYYY-MM-DD"
                    value-type="format"
                    :input-class="'form-control'"
                    style="width:100%"
                  ></date-picker>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Catatan</label>
                  <input type="text" class="form-control" v-model="form.so_notes" />
                </div>
              </div>
            </div>

            <hr />

            <div class="d-flex align-items-center justify-content-between mb-3">
              <h5 class="font-size-15 mb-0">Daftar Produk</h5>
              <button type="button" class="btn btn-secondary btn-sm" @click="addItem">
                <i class="mdi mdi-plus"></i> Tambah Produk
              </button>
            </div>

            <div class="table-responsive">
              <table class="table table-bordered">
                <thead class="thead-light">
                  <tr>
                    <th style="width:35%">Produk</th>
                    <th class="text-center" style="width:14%">Stok Sistem</th>
                    <th style="width:16%">Stok Aktual</th>
                    <th class="text-center" style="width:13%">Selisih</th>
                    <th style="width:17%">Catatan Item</th>
                    <th class="text-center" style="width:5%">Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in items" :key="index">
                    <td>
                      <v-select
                        v-model="item.product"
                        :options="item.productOptions"
                        label="label"
                        placeholder="Cari nama / kode produk..."
                        @search="(q) => searchProduct(q, index)"
                        @input="onProductSelected(index)"
                        :filterable="false"
                      ></v-select>
                    </td>
                    <td class="text-center align-middle">
                      <span class="font-weight-bold">{{ item.stock_system }}</span>
                    </td>
                    <td class="align-middle">
                      <input type="number" class="form-control" v-model.number="item.stock_actual" min="0" @input="calcSelisih(index)" />
                    </td>
                    <td class="text-center align-middle">
                      <span :class="selisihClass(item.selisih)">
                        {{ item.selisih >= 0 ? '+' : '' }}{{ item.selisih }}
                      </span>
                    </td>
                    <td class="align-middle">
                      <input type="text" class="form-control" v-model="item.sod_notes" placeholder="Catatan..." />
                    </td>
                    <td class="text-center align-middle">
                      <button type="button" class="btn btn-sm btn-danger" @click="removeItem(index)" :disabled="items.length === 1">
                        <i class="mdi mdi-delete"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <hr />
            <div class="d-flex justify-content-end">
              <router-link :to="{ name: 'stock_opname_detail', params: { uuid } }" class="btn btn-secondary mr-2">Batal</router-link>
              <button type="button" class="btn btn-primary" @click="update" :disabled="isSaving">
                <i v-if="isSaving" class="mdi mdi-loading mdi-spin mr-1"></i>
                {{ isSaving ? "Menyimpan..." : "Simpan" }}
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      isSaving: false,
      loaded: false,
      module: "Stock Opname",
      table_module: "stock_opname",
      uuid: this.$route.params.uuid,
      form: { so_no: "", so_date: null, so_notes: "" },
      items: [],
    };
  },
  mounted() {
    this.fetchDetail();
  },
  methods: {
    fetchDetail() {
      this.isLoading = true;
      this.axios.get("/" + this.table_module + "/detail/" + this.uuid).then((res) => {
        const d = res.data.data;
        this.form = { so_no: d.so_no, so_date: d.so_date, so_notes: d.so_notes };
        this.items = (d.items || []).map((item) => ({
          product: { value: item.prd_id, label: item.prd_name },
          productOptions: [{ value: item.prd_id, label: item.prd_name }],
          prd_id: item.prd_id,
          stock_system: item.sod_stock_system,
          stock_actual: item.sod_stock_actual,
          selisih: item.sod_selisih,
          sod_notes: item.sod_notes || "",
        }));
        this.loaded = true;
        this.isLoading = false;
      }).catch(() => { this.isLoading = false; this.$toast.error("Gagal memuat data"); });
    },
    searchProduct(query, index) {
      if (query.length < 2) return;
      this.axios.get("/dropdown/autocomplete/products", { params: { "search[prd_name]": query } })
        .then((res) => { this.items[index].productOptions = res.data.data || []; });
    },
    onProductSelected(index) {
      const p = this.items[index].product;
      if (p) {
        this.items[index].prd_id       = p.value;
        this.items[index].stock_system = p.prd_stock || 0;
        this.items[index].stock_actual = p.prd_stock || 0;
        this.items[index].selisih      = 0;
      }
    },
    calcSelisih(index) {
      const item = this.items[index];
      item.selisih = (item.stock_actual || 0) - (item.stock_system || 0);
    },
    selisihClass(val) {
      if (val > 0) return "text-success font-weight-bold";
      if (val < 0) return "text-danger font-weight-bold";
      return "text-muted";
    },
    addItem() {
      this.items.push({ product: null, productOptions: [], prd_id: null, stock_system: 0, stock_actual: 0, selisih: 0, sod_notes: "" });
    },
    removeItem(index) {
      this.items.splice(index, 1);
    },
    update() {
      if (!this.form.so_date) { this.$toast.error("Tanggal wajib diisi"); return; }
      this.isSaving = true;
      const payload = {
        ...this.form,
        items: this.items.filter((i) => i.prd_id).map((i) => ({ prd_id: i.prd_id, sod_stock_actual: i.stock_actual, sod_notes: i.sod_notes })),
      };
      this.axios.post("/" + this.table_module + "/update/" + this.uuid, payload)
        .then(() => {
          this.isSaving = false;
          this.$toast.success("Berhasil disimpan");
          this.$router.push({ name: "stock_opname_detail", params: { uuid: this.uuid } });
        })
        .catch(() => { this.isSaving = false; this.$toast.error("Gagal menyimpan"); });
    },
  },
};
</script>
